import { Pipe, PipeTransform } from '@angular/core';
import {ICategory, ISubcategory} from '@app/core/comp/filtering/filter';
import {SlickIdPipe} from '@app/core/pipes/slick-id.pipe';

@Pipe({
    name: 'ngcCategoryFriendlyName'
})
export class CategoryFriendlyNamePipe implements PipeTransform {

    transform(categoryGuid: string, categories: ICategory[] = []): string {
        let friendlyName = '';

        const mainCategory = categories.find((category: ICategory) => {
            if (category.categoryGuid == categoryGuid) {
                friendlyName = category.categoryName;
                return true;
            } else {
                return category.subcategories.find((subcategory: ISubcategory) => {
                    friendlyName = subcategory.categoryGuid === categoryGuid ? subcategory.categoryName : '';
                    return subcategory.categoryGuid === categoryGuid;
                });
            }
        });

        if (!mainCategory && !friendlyName) {
            friendlyName = new SlickIdPipe().transform(categoryGuid);
        }

        return friendlyName;
    }
}
